<template>
  <div>
    <v-card height="56px" width="100%"
      class="mx-4 pt-5 pr-4 background fixBar elevation-0 d-flex flex-row justify-space-between align-center">
      <v-card-title>
        <span class="breadcrumb-text-unselected underline-on-hover cursor" @click="$router.push('/roles')">Role</span>
        <v-icon class="breadcrumb-arrow-unselected pt-1">mdi-chevron-right</v-icon>
        <span class="breadcrumb-text">Update</span>
        <v-icon class="breadcrumb-arrow pt-1">mdi-chevron-down</v-icon>
      </v-card-title>
      <UserNavMenu />
    </v-card>
    <v-container fluid class="px-8 pad background">

      <v-dialog v-model="successDialog" max-width="366px" class="cdz" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center d-flex flex-column align-center">
              <v-icon color="success" size="96">mdi-check-circle-outline</v-icon>

              <p class="text-h5 py-4">Role Updated</p>

              <v-btn class="btn primary-btn" large width="157px" rounded @click="
                successDialog = false;
              $router.push('/roles');
              ">Ok</v-btn>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>


      <v-row justify="space-between" class="my-0 mt-4">
        <v-col cols="4" sm="4" md="4">
          <div class="text-h6">Update Role</div>
        </v-col>

        <v-col cols="8" sm="8" class="d-flex flex-row justify-end">
          <v-btn class="btn outline-btn" :disabled="!$store.state.role.rolesAndPrivilage.update"
            @click="$router.push('/roles')" rounded>Cancel</v-btn>
          <v-btn  :loading="CLoading" class="btn primary-btn mx-2"
            @click="updateRole_" rounded :disabled="!$store.state.role.rolesAndPrivilage.update || disableSubmit">Update</v-btn>
        </v-col>
      </v-row>

      <div style="height:70vh">

        <v-card elevation="0" class="background">
          <v-card elevation="0" class="pa-4 rounded-lg">
            <v-text-field class="rounded-xl" v-model="roles.roleName" label="Enter Role Name" outlined
              hide-details></v-text-field>

            <div class="text-body-1 my-2">Description</div>
            <v-row>
              <v-col>
                <ckeditor :config="editorConfig" v-model="roles.roleDescription" class="m-ckeditor"
                  @ready="onEditorReady">
                </ckeditor>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-select label="Landing Page" :items="landingPages" outlined class="rounded-xl py-0"
                  v-model="roles.landingUrl" item-text="page" item-value="url"
                  :rules="[(v) => !!v || 'Landing Page is required']">
                </v-select>
              </v-col>
            </v-row>
          </v-card>
        </v-card>

        <v-card elevation="0" class="my-4 py-4 rounded-lg">
          <v-card-title class="text-h6">Role & Permissions</v-card-title>

          <v-card v-for="group in roleGroups" :key="group.title" class="my-4 py-4 rounded-lg" elevation="0">
            <v-row v-for="item in group.items" :key="item.key" class="ma-0 mx-4 mt-2 pa-0" justify="space-between">
              <v-col cols="4" sm="4" md="4" class="ma-0 pa-0 pt-1">
                <v-card-text class="ma-0 pa-0">{{ item.label }}</v-card-text>
              </v-col>

              <v-col cols="8" sm="8" class="d-flex flex-row justify-end ma-0 pa-0">
                <!-- For single permission -->
                <template v-if="item.type === 'single'">
                  <v-checkbox hide-details class="mr-8 mt-0" v-model="roles[item.key]" label="Admin" />
                </template>

                <!-- For CRUD + Read -->
                <template v-else>
                  <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[item.key].create" label="Create"
                    @change="ensureRead(item.key)" />
                  <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[item.key].update" label="Update"
                    @change="ensureRead(item.key)" />
                  <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[item.key].delete" label="Delete"
                    @change="ensureRead(item.key)" />
                  <v-checkbox hide-details class="mr-4 mt-0" v-model="roles[item.key].read" label="Read"
                    :disabled="hasAnyCrud(roles[item.key])" />
                </template>
              </v-col>
            </v-row>
          </v-card>
        </v-card>

      </div>

    </v-container>
  </div>
</template>
     
     
     
<script>
import ClusterController from "@/controllers/ClusterController";
import SchoolController from "@/controllers/SchoolController";
import RolesController from "@/controllers/RolesController";
import AuthService from "../services/AuthService";
import UserNavMenu from "@/components/UserNavMenu.vue";


export default {
  components:{ UserNavMenu },
  name: "UpdateRole",
  data() {
    return {
      clusterData: [
        {
          name: "All Clusters",
          id: "all",
        },
      ],
      schools: [
        { name: "All" }
      ],
      update: false,
      roleId: "",
      CLoading: false,
      successDialog: false,
      adminKeys: [
        "cluster",
        "Brand",
        "board",
        "school",
        "Level",
        "Grade",
        "subjectCategory",
        "subjects",
        "skills",
        "learningObjective",
        "league",
        "topics",
        "interview",
        "candidatesListing",
        "canRestartAssessment"
      ],
      userKeys: [
        "otherAdminOnboarding",
        "rolesAndPrivilage",
        "teacherOnboarding",
      ],
      roles: {
        roleName: "",
        externalRoleId: "",
        dashboard: true,
        canRestartAssessment: false,
        landingUrl:"/",
        clusterName: "",
        users: [],
        schools: [],
        userManagement: { create: false, update: false, delete: false, read: false },
        teacherOnboarding: { create: false, update: false, delete: false, read: false },
        otherAdminOnboarding: { create: false, update: false, delete: false, read: false },
        rolesAndPrivilage: { create: false, update: false, delete: false, read: false },

        masters: { create: false, update: false, delete: false, read: false },
        cluster: { create: false, update: false, delete: false, read: false },
        Brand: { create: false, update: false, delete: false, read: false },
        school: { create: false, update: false, delete: false, read: false },
        board: { create: false, update: false, delete: false, read: false },
        Level: { create: false, update: false, delete: false, read: false },
        Grade: { create: false, update: false, delete: false, read: false },
        subjectCategory: { create: false, update: false, delete: false, read: false },
        subjects: { create: false, update: false, delete: false, read: false },
        skills: { create: false, update: false, delete: false, read: false },
        learningObjective: { create: false, update: false, delete: false, read: false },
        league: { create: false, update: false, delete: false, read: false },

        dashboard: false, // Single checkbox
        campaign: { create: false, update: false, delete: false, read: false },
        assessment: { create: false, update: false, delete: false, read: false },
        questionBank: { create: false, update: false, delete: false, read: false },
        topics: { create: false, update: false, delete: false, read: false },
        interview: { create: false, update: false, delete: false, read: false },
        candidatesListing: { create: false, update: false, delete: false, read: false },

        canRestartAssessment: false // Single checkbox
      },

      roleGroups: [
        {
          title: 'Module Permissions',
          items: [
            { key: 'userManagement', label: 'User Management' },
            { key: 'teacherOnboarding', label: 'Teacher Onboarding' },
            { key: 'otherAdminOnboarding', label: 'Other Admin Onboarding' },
            { key: 'rolesAndPrivilage', label: 'Roles & Privilege' }
          ]
        },
        {
          title: 'Masters',
          items: [
            { key: 'masters', label: 'Masters' },
            { key: 'cluster', label: 'Cluster' },
            { key: 'Brand', label: 'Brand' },
            { key: 'school', label: 'School' },
            { key: 'board', label: 'Board' },
            { key: 'Level', label: 'Level' },
            { key: 'Grade', label: 'Grade' },
            { key: 'subjectCategory', label: 'Subject Category' },
            { key: 'subjects', label: 'Subjects' },
            { key: 'skills', label: 'Skills' },
            { key: 'learningObjective', label: 'Learning Objective' },
            { key: 'league', label: 'League' }
          ]
        },
        {
          title: 'Platform Access',
          items: [
            { key: 'dashboard', label: 'Dashboard', type: 'single' },
            { key: 'campaign', label: 'Campaign' },
            { key: 'assessment', label: 'Assessment' },
            { key: 'questionBank', label: 'Question Bank' },
            { key: 'topics', label: 'Topics' },
            { key: 'interview', label: 'Interview' },
            { key: 'candidatesListing', label: 'Candidate Listing For Hiring Manager' },
            { key: 'canRestartAssessment', label: 'Restart Assessment', type: 'single' }
          ]
        }
      ],
      editorConfig: {
        extraPlugins: "ckeditor_wiris",
      },
      editorConfigForOption: {
        extraPlugins: "ckeditor_wiris",
      },
      landingPages:[
        {
          page:"Dashboard",
          url:"/"
        },
        {
          page:"Candidate Listing",
          url:"/candidate-list"
        },
        {
          page:"Question Bank",
          url:"/question-bank"
        }
      ]
    };
  },

  methods: {
    onEditorReady(editor) {
      editor.on("afterCommandExec", function(event) {
        var commandName = event.data.name;
        if(['ckeditor_wiris_openFormulaEditor', 'ckeditor_wiris_openFormulaEditorChemistry'].includes(commandName) ) {
          setTimeout(() => {
              const wiris_license_overlays = document.querySelectorAll('.wrs_tickContainer')
              wiris_license_overlays.forEach(element => {
                element.remove();
              });
            }, 2000)
        }
      })
    },
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },
    moveToRole() {
      this.$router.push("/roles");
    },


    async updateRole_() {
      this.CLoading = true;
      // this.$store.state.role = this.roles
      //  console.log("create role store", this.$store.state.role);
      const response = await RolesController.updateRole(this.roles, this.roles.id);
      if (response.data.flag) {
        this.CLoading = false;
        this.successDialog = true;
        this.$store.state.updateRole = null
      } else {
        alert("Failed");
      }
      console.log("Update role", response);
    },


    async fetchAllClusters() {
      const response = await ClusterController.getAllClusters();
      console.log("clusters response", response);
      if (response.data.flag) {
        console.log(response);

        var data = response.data.clusters;
        this.clusterData = [...this.clusterData, ...data];
      } else {
        alert(response.data.error);
      }
    },
    ensureRead(key) {
      const role = this.roles[key];
      // If any of the CRUD is checked, force Read = true
      if (role.create || role.update || role.delete) {
        role.read = true;
      }
      // If none are checked, do not force Read to false — user can toggle
    },

    hasAnyCrud(role) {
      return role.create || role.update || role.delete;
    }
  },
  async mounted() {

    // add event listener for beforeunload event
    if (!this.$store.state.role.rolesAndPrivilage.read) {
      this.$router.push("/notFound");
    }
    this.fetchAllClusters();
    if (this.$store.state.updateRole != null) {
      console.log("in if block")
      this.roles = Object.assign(this.roles, this.$store.state.updateRole)
      let roleDescription = this.roles.roleDescription
      setTimeout(()=>{
        this.roles.roleDescription = roleDescription
      }, 1000) 
    }
    else {
      console.log("in else block")
      this.$router.push("/roles")
    }
  },

  watch: {

  },
  created() {

  },
  computed: {
    disableSubmit() {
      let data = !Object.values(this.roles).some(role => {
      if (typeof role === 'boolean') {
        // Direct boolean permission like `dashboard: true`
        return role === true;
      } else if (typeof role === 'object' && role !== null) {
        // Object permissions like `campaign: { create: true, ... }`
        return Object.values(role).some(val => val === true);
      }
      return false; // Safety fallback for unexpected types
    });
    return data
    }
  },
};
</script>